// Physical dimensions of the flat-top hex model rendered by the WebGL scene.
//
// Lives outside HexGrid.tsx on purpose: HexSilhouettes imports HEX_HEIGHT from
// here, and HexGrid imports the React-rendered HexSilhouettes component — a
// direct cross-import would be a cycle, and Rollup's bundled evaluation order
// then leaves HexSilhouettes in TDZ when it first touches HEX_HEIGHT
// (`Cannot access 'uo' before initialization` in the production bundle).
// Hoisting these two numbers to a leaf module breaks the cycle.

export const HEX_SIZE = 1;
export const HEX_HEIGHT = 0.2;
